export const DEFAULT_SORT_FOR_SEARCH: Array<{
  field: string;
  dir: "asc" | "desc";
}> = [
  {
    field: "date_of_service",
    dir: "asc",
  },
  {
    field: "created_at",
    dir: "asc",
  },
];
